import { jsx as r, jsxs as h } from "react/jsx-runtime";
import { forwardRef as l } from "react";
import { FormToggle as x } from "../FormToggle/FormToggle.js";
import { IconCheck as k } from "../Icons/index.js";
import { checkboxVariants as t } from "./Checkbox.variants.js";
const C = l(
  ({
    isDisabled: o = !1,
    isInvalid: e = !1,
    variant: c = t.definition().defaultVariants.variant,
    ...m
  }, a) => {
    const { control: n, input: s, shape: f, icon: p } = t;
    return /* @__PURE__ */ r(x, { isDisabled: o, isInvalid: e, ...m, children: (i) => /* @__PURE__ */ h("div", { className: n(), children: [
      /* @__PURE__ */ r(
        "input",
        {
          ...i,
          className: s({ isDisabled: o }),
          ref: a,
          type: "checkbox"
        }
      ),
      /* @__PURE__ */ r("div", { className: f({ isDisabled: o, isInvalid: e, variant: c }) }),
      /* @__PURE__ */ r(
        k,
        {
          className: p({ isDisabled: o, isInvalid: e, variant: c }),
          size: "sm"
        }
      )
    ] }) });
  }
);
export {
  C as Checkbox
};
